import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { ConfirmEmailGate } from './ConfirmEmailGate';
import { Skeleton } from '@/components/ui/skeleton';

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="space-y-4 w-full max-w-md p-8">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  /*
   * La contrepartie côté écran de la garde globale `ConfirmedEmailGuard` : le
   * back répond 403 sur tout ce qui suit le login tant que l'adresse n'est pas
   * confirmée, donc laisser passer ici ne montrerait que des panneaux en erreur.
   *
   * `=== false` ET NON `!emailConfirmed`. Le champ est optionnel dans le type,
   * et Amplify livre le front à chaque push quand le back attend les E2E : une
   * réponse `/auth/me` d'avant le champ ferait, avec un test de véracité,
   * basculer TOUT LE MONDE derrière cet écran. Seul un `false` explicite —
   * c'est-à-dire un back qui a vraiment répondu « non » — ferme la porte.
   */
  if (user.emailConfirmed === false) {
    return <ConfirmEmailGate />;
  }

  return <Outlet />;
}
